/** A row another surface points at — e.g. the booking time axis's "show this delivery":
 *  the host passes the row id, the grid tints that row (`getRowClassName` + `sx`). A
 *  background tint only, like a selection — never a side stripe (DESIGN.md). */
import { alpha, type Theme } from '@mui/material';

const TARGET_ROW_CLASS = 'row-target';

export const TARGET_ROW_SX = {
  [`& .MuiDataGrid-row.${TARGET_ROW_CLASS}`]: { bgcolor: (t: Theme) => alpha(t.palette.primary.main, 0.08) },
} as const;

/** `getRowClassName` for the row whose id is `highlightId`. */
export function targetRowClassName(highlightId: string | null | undefined) {
  return (p: { id: string | number }) => (highlightId && String(p.id) === highlightId ? TARGET_ROW_CLASS : '');
}
